var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMySymmioLicense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symmio Plus Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 348",
    width: 80,
    height: 80,
    rx: 20,
    fill: "#121622"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.0641 36.7062C61.0199 31.3305 52.6988 24.4263 50.3424 23.1267L48.5014 22.1107L47.5058 23.9931C46.2805 26.3148 45.0816 28.5481 43.874 30.6715C43.1564 29.8097 42.3881 28.9946 41.5735 28.2308L41.55 28.2125C32.6191 20.0239 24.1272 20.9605 19.1581 24.5667C14.2891 28.0996 12.2891 34.2533 14.295 39.5283C16.4276 45.1267 25.2288 52.6319 26.7605 53.7791L27.8592 54.6028L29.0374 53.9041C38.522 48.2722 44.1244 39.3025 50.089 28.1545C53.0169 30.4366 57.9477 35.0923 59.1672 38.2988C60.3454 41.4229 58.8048 45.502 55.4794 47.9976C53.7768 49.2759 47.7149 52.879 39.9829 46.6247C39.008 47.6839 37.9816 48.691 36.9078 49.642C45.0551 56.5371 53.1082 55.1337 57.9389 51.5183C62.8667 47.8176 64.9757 41.7371 63.0641 36.7062ZM28.1419 49.3888C25.2612 46.9481 19.5145 41.3924 18.1978 37.9357C16.9048 34.537 18.2891 30.5007 21.5646 28.124C23.3416 26.8751 25.4437 26.2164 27.5911 26.2355C30.5366 26.2355 34.3511 27.4101 38.7605 31.4465C39.7893 32.4052 40.7174 33.4739 41.5293 34.6346C37.7267 40.7639 33.6265 45.804 28.1419 49.3888Z",
    fill: "url(#paint0_linear_5541_33640)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 347",
    x: 51.6218,
    y: 43.3588,
    width: 17.28,
    height: 17.28,
    fill: "#121622"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M59.9404 54.8838V60.6438H63.1404V54.8838H68.9004V51.6838H63.1404V45.9238H59.9404V51.6838H54.1804V54.8838H59.9404Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5541_33640",
    x1: 66.0261,
    y1: 58.9669,
    x2: 17.135,
    y2: 23.3145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43B5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567584,
    stopColor: "#ADDFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMySymmioLicense);
export default __webpack_public_path__ + "static/media/icon_my-symmio-license.2e045d0937b02fea48f3e5d5d1c2da92.svg";
export { ForwardRef as ReactComponent };